<template>
    <div class="enter-page">
        <div class='topBanner'>
            <TopBar :changeBg="true"/>
            <!-- <div class='piclist' v-for="(item, index) in config.ad" :key="index">
                <img :src="item.image">
            </div> -->
            <Banner :list="config.ad" v-if="config && config.ad" height="500px"></Banner>
        </div>
        <!-- <div class='warp-text' v-if="config.text">{{config.text}}</div> -->
        <Title>申请入驻</Title>
        <div class='warp-enter'>
            <Enter :list="config.settled_list" :enterIntercept="config.enterIntercept"/>
        </div>
        <FootBar/>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import FootBar from '@components/footBar'
import TopBar from '@components/topBar'
import Title from '@components/title/level2Title'
import Banner from '../home/components/banner'
import Enter from '../home/components/enter'

export default {
    data() {
        return {
            config: []
        }
    },
    async created() {
        this.$store.dispatch('getUserInfo')
        this.$store.dispatch('pages/home/getCmsHome')
        const type = 'enterData'
        const res = await this.$store.dispatch('enter/getCMSConfig')
        const config = res.data || {}
        this.config = config[type]
    },
    components: {
        TopBar,
        FootBar,
        Banner,
        Enter,
        Title
    }
}
</script>
<style lang="scss" scoped>
.enter-page{
    img{
        width: 100%;
    }
    .warp-text{
        height: 114px;
        line-height: 114px;
        text-align: center;
        background-color:#e4e4e4;
    }
    .level2-title{
        text-align: center;
        width: 100%;
    }
    .warp-enter{
        margin-top: 19px;
    }
}
</style>
